// extracted by mini-css-extract-plugin
export default {"wrap":"CadDemos_wrap__ljBGG","svg":"CadDemos_svg__dkgFR","caption":"CadDemos_caption__Ljpix","wrapBare":"CadDemos_wrapBare__7-LRY","svgBare":"CadDemos_svgBare__cEi-o"};